import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAnalysisPackage } from '@irb/irb-editors/rebalance/irb-rebalance.model';
import { Observable } from 'rxjs';
import {AppService} from "@irb/app.service";

@Injectable({
    providedIn: 'root'
})
export class IrbCreateRebalanceService {
    httpOptions = {
        headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
        })
    };
    constructor(private readonly http: HttpClient, private as: AppService) { }

    createNewRebalances(icreateRebalance: ICreateRebalance): Observable<any> {
        return this.http.post('/irebalone/rebalance-portfolios/create-new-rebalance', JSON.stringify(icreateRebalance), this.httpOptions);
    }
    createRebalWithPortfolios(icreateRebalance: ICreateRebalance): Observable<any> {
        return this.http.post('/irebalone/rebalance-portfolios/create-rebal-with-portfolios', JSON.stringify(icreateRebalance), this.httpOptions);
    }
    getRebalancePortDetail(icreateRebalance: ICreateRebalance): Observable<any> {
        return this.http.post('/irebalone/rebalance-portfolios/get-rebalance-port-detail', JSON.stringify(icreateRebalance), this.httpOptions);
    }

    saveRebalance(iAnalysisPackage: IAnalysisPackage): Observable<any> {
        return this.http.post('/irebalone/rebalance-portfolios/save-rebalance', JSON.stringify(iAnalysisPackage), this.httpOptions);
    }

    saveRebalanceAsync(iAnalysisPackage: IAnalysisPackage): Observable<any> {
        return this.http.post('/irebalone/rebalance-portfolios/save-rebalance-async', JSON.stringify(iAnalysisPackage), this.httpOptions);
    }

    getSaveRebalanceStatus(rprasId: string): Observable<Object> {
        return this.http.get("/irebalone/rebalance-portfolios/rebalance-status/" + rprasId, this.httpOptions);
    }
    
    getVeoNonProcessingDays(): Observable<Object> {
        return this.http.get("/irebalone/rebalance-portfolios/get-veo-non-processing-days", this.httpOptions);
    }
    
    submitPortfoliosToQueue(res: any): Observable<any> {
        return this.http.post('/irebalone/rebalance-portfolios/submit-portfolios-to-queue', JSON.stringify(res), this.httpOptions);
    }
    getIdsByFilterCriteria(config: any): Observable<any> {
        if (config.serviceURL) {
            return this.http.post(config.serviceURL,
                { 'isSelectAll': true }, this.httpOptions);
        }
    }
    getSmartFilteredPortfolios(res: IPortfoliosByModel): Observable<any> {
        return this.http.post('/irebalone/rebalance-portfolios/get-smart-filtered-portfolios', JSON.stringify(res), this.httpOptions);
    }
    getRebalanceTypeListObject(isTlhWsaEnabled: boolean) {
        const rebalanceTypeList: any = [
            {
                label: 'Full rebalance', 'value': '1', disableSubmit: false,
                disableEditParameters: false,
                glabel: 'Full rebalance', 'gvalue': 'FULL_REBAL', groupSeparater: true, disableContinue: false,
            },

            {
                'label': 'Generate and/or invest cash', 'value': '2', disableSubmit: false, disableEditParameters:
                    false,
                glabel: 'Manage cash only', gvalue: 'MANAGE_CASH', disableContinue: false
            },
            {
                'label': 'Generate cash only', 'value': '3', disableSubmit: false, disableEditParameters: false,
                glabel: 'Manage cash only', gvalue: 'MANAGE_CASH', disableContinue: false
            },
            {
                'label': 'Invest cash only', 'value': '4', disableSubmit: false, disableEditParameters: false,
                glabel: 'Manage cash only', gvalue: 'MANAGE_CASH', groupSeparater: true, disableContinue: false,
            },
            {
                'label': 'Adjust securities', 'value': '5', disableSubmit: true, disableEditParameters: true,
                glabel: 'Directed trading', 'gvalue': 'DIRECT_TRADE', disableContinue: true
            },
            {
                'label': 'Tax Loss Harvest', 'value': '6', disableSubmit: true, disableEditParameters: true,
                glabel: 'Directed trading', 'gvalue': 'DIRECT_TRADE', disableContinue: true,
            },
            {
                'label': 'Replace securities', 'value': '8', disableSubmit: true, disableEditParameters: true,
                glabel: 'Directed trading', 'gvalue': 'DIRECT_TRADE', disableContinue: true
            },
            {
                'label': 'Manual adjustment', 'value': '9', disableSubmit: false, disableEditParameters: false,
                glabel: 'Directed trading', 'gvalue': 'DIRECT_TRADE', disableContinue: false
            },
            {
                'label': 'Covered call', 'value': '10', disableSubmit: true, disableEditParameters: true,
                glabel: 'Directed trading', 'gvalue': 'DIRECT_TRADE', disableContinue: true
            }
        ];
        const ENABLE_TLH_FR = this.as.getItem('IRB_APP_CONFIG')?.featureFlags.ENABLE_TLH_FR || false;
        if (isTlhWsaEnabled && ENABLE_TLH_FR) {
            const itemTLH_Full = {
                'label': 'Tax Loss Harvest and Full Rebalance',
                'value': '7',
                disableSubmit: false,
                disableEditParameters: false,
                glabel: 'TLH FULL REBALANCE',
                'gvalue': 'TLH_FULL_REBALANCE',
                groupSeparater: true,
                disableContinue: false,
                customToolTipWhenDisabled: 'Configure tax loss harvest settings from iRebal settings before selecting this option.'
            };
            rebalanceTypeList.splice(6, 0, itemTLH_Full);
        }
        return rebalanceTypeList;
    }
}


export interface ICreateRebalance {
    analysisType?: string;
    scheduleType?: string;
    rebalanceType?: string;
    rebalanceSubType?: string;
    portfolioArray?: Array<number>;
    portfolioDtoList?: Array<number>;
    analysisId?: any;
    schedulerId?: any;
    testFlag?: number;
    selectAllPort?: boolean;
    navBackModule?: string;
    investCashSetting?: string;
}

export interface IRebalanceTypeItem {
    label: string;
    value: string;
    glabel: string;
    gvalue: string;
    disableSubmit: boolean;
    disableEditParameters: boolean;
    groupSeparater?: boolean;
    disableContinue: boolean;
    customToolTipWhenDisabled?: string;
    notClickableItem?: boolean;
    class?: Array<string>;
}
export interface IPortfoliosByModel {
    analysisId: string,
    analysisPortDtoList: Array<any>,
    analysisType: string,
    isCategoryAll: boolean,
    isCategoryBlank: boolean,
    isModelAll: boolean,
    isModelBlank: boolean,
    modelUpdated: boolean,
    sfCategoryDtoList: Array<any>,
    sfModelDtoList: Array<any>,
    smartFilterDays: any
}
